import BackgroundImage from 'gatsby-background-image';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { Box, Flex } from 'rebass/styled-components';

import { layout } from '../../../../constants/constants';
import useFeatureToggle from '../../../hooks/use-feature-toggle/useFeatureToggle';
import useWindowSize from '../../../hooks/window-size/useWindowSize';
import { FeatureToggle, BackgroundMediaHeroContent, IconPack } from '../../../models/app-data-model';
import Breadcrumbs from '../../bread-crumbs/breadcrumbs';
import ButtonWrapper from '../../button-wrapper/button-wrapper';
import './background-media.scss';

export type HeroContentProps = {
  heroContent: BackgroundMediaHeroContent;
  featureToggles: FeatureToggle[];
  iconPack: IconPack[];
};

const HeroBackgroundMedia: React.FC<HeroContentProps> = ({ heroContent, featureToggles, iconPack }: HeroContentProps) => {
  const windowSize = useWindowSize();
  const [isTabletOrSmaller, setIsTabletOrSmaller] = useState<boolean>();
  const showHeroBackgroundMedia: boolean = useFeatureToggle('hero-background-media', featureToggles);

  useEffect(() => {
    if (windowSize?.width && windowSize.width < 960) {
      setIsTabletOrSmaller(true);
    } else {
      setIsTabletOrSmaller(false);
    }
  }, [windowSize]);

  const {
    header,
    desktop_image: imageDesktop,
    mobile_image: imageMobile,
    subtext,
    primary_button: primaryButton,
    secondary_button: secondaryButton,
    breadcrumbs,
    text_color: textColor
  } = heroContent;

  if (!showHeroBackgroundMedia) {
    return null;
  }

  const sources = [
    imageMobile?.file?.localAsset?.childImageSharp?.fluid,
    {
      ...imageDesktop?.file?.localAsset?.childImageSharp?.fluid,
      media: `(min-width: 960px)`
    }
  ];

  return (
    <div className="background-media" data-testid={isTabletOrSmaller ? 'mobile' : 'desktop'}>
      <BackgroundImage className="background-image" fluid={sources}>
        <span role="img" aria-label={isTabletOrSmaller ? imageMobile?.alt_text : imageDesktop?.alt_text} />
        <Flex className="hero-block">
          <Box className="content-container" width={layout.pageWidth} px={layout.pagePaddingX} marginX={'auto'}>
            <div className={`text ${textColor}`}>
              {breadcrumbs && <Breadcrumbs breadcrumbsContent={breadcrumbs}></Breadcrumbs>}
              {header && <h1 className="header">{header}</h1>}
              {subtext && <p className="subtext">{subtext}</p>}
            </div>
            <div className={`actions ${textColor}`}>
              {primaryButton?.text && primaryButton?.reference && (
                <ButtonWrapper type="primary" label={primaryButton.text} reference={primaryButton.reference} iconPack={iconPack} />
              )}
              {secondaryButton?.text && secondaryButton?.reference && (
                <ButtonWrapper type="secondary" label={secondaryButton.text} reference={secondaryButton.reference} iconPack={iconPack} />
              )}
            </div>
          </Box>
        </Flex>
      </BackgroundImage>
    </div>
  );
};

export default HeroBackgroundMedia;
